export default "__VITE_ASSET__DHy8i7EP__"